import loadable from '@loadable/component';

export const OrgDashboardCreateJobPageLoadable = loadable(
  () => import('./OrgDashboardCreateJobPage'),
  { resolveComponent: (module) => module.OrgDashboardCreateJobPage },
);
